import { blue, green, grey, indigo, red } from "@material-ui/core/colors";

import { createMuiTheme } from "@material-ui/core/styles";

const theme = createMuiTheme({
  palette: {
    primary: {
      main: indigo[900],
      light: "hsl(240, 40%, 49%)",
      dark: "#003368",
      contrastText: "hsl(0, 0%, 100%)",
    },
    secondary: {
      main: blue[500],
      light: "hsl(207, 100%, 72%)",
      dark: "#0538A0",
      contrastText: "#000",
    },
    error: {
      main: red.A400,
    },
    background: {
      paper: "hsl(0, 0%, 100%)",
      default: "hsl(213, 61%, 93%)",
    },
    success: {
      main: green.A700,
    },
    grey: {
      300: grey[300],
      500: grey[500],
      800: grey[700],
    },
  },
  typography: {
    h1: {
      fontSize: "1.5rem",
      fontWeight: 600,
    },
    h2: {
      fontSize: "1.4rem",
      fontWeight: 550,
      marginBottom: "0.5rem",
    },
    h3: {
      fontSize: "1.2rem",
      fontWeight: 600,
    },
    h4: {
      fontSize: "1rem",
      fontWeight: 600,
      marginBottom: "0.25rem",
      color: "#003368",
    },
  },
  overrides: {
    MuiTableCell: {
      root: {
        textAlign: "center",
        "& > div": {
          justifyContent: "center",
        },
      },
      paddingCheckbox: {
        padding: "0 0 19px 4px",
      },
    },
    MuiCardContent: {
      root: {
        padding: "13px",
      },
    },
  },
});

export default theme;
